import React from 'react';
import { useParams } from 'react-router-dom';
import ContainerComponent from '../../helpers/components/container.component';
import MyInvoisDetailLayout from './components/myinvois_detail_layout';

const MyInvoisDetail = () => {
    const { document_id } = useParams();
    return (
        <>
            <ContainerComponent span={20} top={20} bottom={20}>
                <MyInvoisDetailLayout document_id={document_id} />
            </ContainerComponent>
        </>
    );
}

export default MyInvoisDetail;